import React from "react";
import "./notfound.scss";
import {Link} from "react-router-dom";

const Notfound = ({children}) => (
    <div className="notfound-container-bg">
        <h1>404</h1>
        <h2>Uh oh! The page is not found</h2>
        <Link to="/jobs/my-jobs">click to go back</Link>
    </div>
);

export default Notfound;
